// extracted by css-extract-rspack-plugin
export default {"suggestionTitle":"use-reference-suggestions-module__suggestionTitle__mdjWd"};